import React, { useEffect, useLayoutEffect } from 'react'
import { Container } from 'reactstrap'
import Immutable from 'immutable'
import { Route, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import RoadBookingNavbar from './RoadBookingNavbar'
import { ROAD_BOOKING_SEARCH_PATH, ROAD_BOOKING_SELECTION_SEAT_PATH } from '../../../config/paths'
import { getActiveSalesSession, getSearchItineraryRoadBooking } from '../../../actions'
import RoundTrip from './RoundTrip'
import RoadBookingSelection from './selection/RoadBookingSelection'

const RoadBookingModule = ({ currentStep, dispatchGetActiveSalesSession, user, dispatchGetSearchItineraryRoadBooking, currentSession }) => {

  const verifyActiveSalesSession = () => {
    if (user) dispatchGetActiveSalesSession({ source: ROAD_BOOKING_SEARCH_PATH });
  }

  useEffect(() => {
    verifyActiveSalesSession();
  }, []);

  useLayoutEffect(() => {
    if (!currentSession.isEmpty()) {
      dispatchGetSearchItineraryRoadBooking();
    }
  }, [currentSession]);

  return (
    <div>
      <Container fluid>
        <h1>Venta en paradas autorizadas</h1>
        <RoadBookingNavbar currentStep={currentStep} />
        <Switch>
          <Route exact path={ROAD_BOOKING_SEARCH_PATH} render={RoundTrip} />
          <Route path={ROAD_BOOKING_SELECTION_SEAT_PATH} render={RoadBookingSelection} />
        </Switch>
      </Container>
    </div>
  )
}

RoadBookingModule.propTypes = {
  dispatchGetActiveSalesSession: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.number.isRequired,
    securityProfileSet: PropTypes.arrayOf(
      PropTypes.shape({
        viewAuthorizationList: PropTypes.arrayOf(
          PropTypes.shape({
            view: PropTypes.shape({
              route: PropTypes.string,
            }),
          }),
        ).isRequired,
      }),
    ).isRequired,
    salesSessionUserId: PropTypes.number,
  }).isRequired,
  currentStep: PropTypes.number.isRequired,
  dispatchGetSearchItineraryRoadBooking: PropTypes.func.isRequired,
  currentSession: PropTypes.instanceOf(Immutable.Map).isRequired,
}

const mapStateToProps = ({ authentication, BookingUnit, SalesUnit }) => ({
  user: authentication.get('user'),
  currentStep: BookingUnit.Booking.getIn(['roadBooking', 'currentStep']),
  submitting: BookingUnit.Booking.getIn(['payment', 'postingPayment']),
  currentSession: SalesUnit.SalesSession.getIn(['active', 'content']),
})

const mapDispatchToProps = {
  dispatchGetActiveSalesSession: getActiveSalesSession,
  dispatchGetSearchItineraryRoadBooking: getSearchItineraryRoadBooking,
}

export default connect(mapStateToProps, mapDispatchToProps)(RoadBookingModule)
